export class DeliveryInstructionManagementCollections {
  static ModuleName = 'delivery';

  static DeliveryInstructions = `${DeliveryInstructionManagementCollections.ModuleName}/instructions`;
  static deliveryInstruction(id: string) {
    return `${DeliveryInstructionManagementCollections.DeliveryInstructions}/${id}`;
  }
}
